import _ from 'lodash';

export const mergeRoutes = (currentRoutes = [], newRoutes = []) =>
  _.unionBy([...currentRoutes, ...newRoutes], 'path');
